// import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

import AuditPage from './AuditList.page';

const query = gql`
  query log($offset: Int, $where: custom_filter_audit_bool_exp) {
    custom_filter_audit(
      order_by: { created_at: desc }
      limit: 10
      offset: $offset
      where: $where
    ) {
      id
      employee_name
      company_name
      service
      operation_type
      created_at
    }
    custom_filter_audit_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export default graphql(query)(injectIntl(AuditPage));
